module.exports = __webpack_public_path__ + "img/img_intro_001.7b701997.jpg";